import { BrowserRouter as Router } from "react-router-dom";
import NetworkStatusBanner from "./components/Common/NetworkStatusBanner";
import { AuthProvider } from "./contexts/AuthContext";
import { SignalRProvider } from "./contexts/SignalRContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <ThemeProvider>
      <div className="relative">
        <NetworkStatusBanner />
        <Router>
          <AuthProvider>
            <SignalRProvider
              connectionUrl={`${process.env.REACT_APP_API_BASE_URL_SIGNALR}/notificationHub`}
            >
              <AppRoutes />
            </SignalRProvider>
          </AuthProvider>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
